/**
 * Post-stay guest reviews (TASK-43). A guest submits a rating/review after
 * checkout via booking-reference + PIN lookup; super-admin moderates; the
 * storefront shows real aggregate ratings.
 */

export enum ReviewStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  HIDDEN = 'hidden',
}

export interface Review {
  id: string;
  propertyId: string;
  bookingId: string | null;
  guestName: string;
  rating: number; // 1–5
  title: string | null;
  body: string | null;
  status: ReviewStatus;
  createdAt: string;
  updatedAt: string;
}

/** Public submit — guest proves the stay with booking reference + PIN. */
export interface SubmitReviewRequest {
  bookingReference: string;
  pin: string;
  rating: number; // 1–5
  title?: string;
  body?: string;
}

export interface SubmitReviewResponse {
  ok: true;
  id: string;
}

/** Public aggregate shown on the storefront, replacing the placeholder numbers. */
export interface PropertyRatingSummary {
  propertyId: string;
  averageRating: number; // rounded to 1 dp
  reviewCount: number;
}

/** One approved review for public display. */
export interface PublicReview {
  id: string;
  guestName: string;
  rating: number;
  title: string | null;
  body: string | null;
  createdAt: string;
}
